module.exports = __webpack_public_path__ + "static/back_picture_blue-a820760a628d4dea68e574f2885c77fa.svg";